import 'jquery.maskedinput/src/jquery.maskedinput';
import '../../../vendors/elasticattr/elasticAttr';
// require responsive_image/jquery.imageSeo
import '../../../vendors/responsive_image/jquery.responsiveImage';
import '../../../vendors/lazyload/jquery.unveil';
import '../../../vendors/cutter/vcutter.min';
import '../../../vendors/transit/jquery.transit.min';
import '../../../vendors/responsive_carousel/responsiveCarousel';
import '../../../vendors/owlCarousel2/owl.carousel.min';
// require salvattore/salvattore.min
//import '../../../vendors/pickadate.js-3.5.6/index'
import '../../../vendors/pagination/pagination.min';
// require lodash/lodash_4_17_11
// require croppie/dist/croppie
import '../../../vendors/magnific-popup/magnific-popup';
import '../../../vendors/template7-1.4.1/dist/template7.min';
// require lightSlider/dist/js/lightslider.min
import '../../../vendors/lightGallery/dist/js/lightgallery-all.min';
import '../../../vendors/video-bg-youtube/jquery.youtube-background';

// AUTOEXECUTE
import './automodules';

// VENDORS CSS
